import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-01f2c77e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-layout" }
const _hoisted_2 = { class: "auth-layout-content" }
const _hoisted_3 = { class: "auth-layout-content-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "nexusmedx"
}, null, -1))
const _hoisted_5 = { class: "stretch" }
const _hoisted_6 = { class: "copyright" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "email",
  href: "mailto:help@nexusmedx.com"
}, "help@nexusmedx.com", -1))
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<aside class=\"auth-layout-aside\" data-v-01f2c77e><div class=\"auth-layout-aside-inner\" data-v-01f2c77e><h3 class=\"welcome\" data-v-01f2c77e>Welcome to NexusMedX</h3><p class=\"desc\" data-v-01f2c77e>Trusted US &amp; Global CME/CE platform bringing you quality Continuing Education Courses and Learning Centers in dissemination with leading medical publishers worldwide</p><ul class=\"physician-list\" data-v-01f2c77e><li class=\"physician-item last\" data-v-01f2c77e><span class=\"join\" data-v-01f2c77e>Join 10,000+ physicians</span></li></ul></div></aside>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("header", null, [
          _createVNode(_component_router_link, {
            to: { name: $setup.routesName.landing }
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("footer", null, [
          _createElementVNode("div", _hoisted_6, "© NexusMedX  " + _toDisplayString($setup.dayjs().format("YYYY")) + " .", 1),
          _hoisted_7
        ])
      ])
    ]),
    _hoisted_8
  ]))
}